module.exports = __webpack_public_path__ + "static/media/faq.96d91665.svg";